import { render } from "./LogoLoader.vue?vue&type=template&id=edca8e28"
import script from "./LogoLoader.vue?vue&type=script&lang=js"
export * from "./LogoLoader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__